import request, { requestSet, METHOD } from '@/utils/request'

// /查询零星预测管理列
export function apiScpDmSporadicList (query) {
  return request({
    url: '/scp/scpDmSporadic/list',
    method: 'get',
    params: query
  })
}
  // /修改零星预测管理
export function apiScpDmSporadic (data) {
    return request({
      url: `/scp/scpDmSporadic/operate`,
      method: 'put',
      data: data
    })
  }
  // /修改零星预测管理
  export function apiscpDmQuantity (data) {
    return request({
      url: `/scp/scpDmQuantity`,
      method: 'post',
      data: data
    })
  }
    // 查询需求数量列表
    export function apiscpDmQuantityList (data) {
      return request({
        url: `/scp/scpDmQuantity/list`,
        method: 'get',
        params: data
      })
    }
    // 导出列表
    export function apiScpDmSporadicNewExport (data) {
      return request({
        url: '/scp/scpDmSporadic/v2/export',
        method: 'post',
        data: data
      })
    }
    // 修改零星预测管理
    export function apiScpFcSporadic (data) {
      return request({
        url: `/scp/scpFcSporadic`,
        method: 'put',
        data: data
      })
    }
      // /修改零星需求管理
export function apiScpDmSporadicState (data) {
  return request({
    url: `/scp/scpDmSporadic`,
    method: 'put',
    data: data
  })
}

/**
 * 零星导入
 * @returns {Promise<AxiosResponse<T>}
 */
export async function apiImportSporadic(params) {
  return requestSet(`/scp/scpDmSporadic/importSporadic`, METHOD.POST, params, { responseType: "blob" });
}
